import React, { useEffect, useState } from 'react';
import './AccessHistoryPage.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faLongArrowAltLeft } from '@fortawesome/free-solid-svg-icons';
import { PaginationComponent } from 'pages/SearchPage/components/Pagination';
import { useAccessHistoryContext } from 'contexts/AccessHistoryContext';
import { useUserContext } from 'store';
import { LoadingHU } from 'components/LoadingHU';
import { TableAccessHistory } from './components';

library.add(faLongArrowAltLeft);

export function AccessHistoryPage() {
  const [user] = useUserContext();
  const { accessHistoryList, loading } = useAccessHistoryContext();
  const [filteredHistoryData, setFilteredHistoryData] = useState([]);
  const [seeAllHistoryOrMyHistory, setSeeAllHistoryOrMyHistory] = useState('seeAll');
  const [itensPerPage, setItensPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const pages = Math.ceil(filteredHistoryData.length / itensPerPage);
  const startIndex = currentPage * itensPerPage;
  const endIndex = startIndex + itensPerPage;

  function handleAllHistory() {
    setSeeAllHistoryOrMyHistory('seeAll');
    setCurrentPage(0);
  }

  function handleMyHistory() {
    setSeeAllHistoryOrMyHistory('seeMine');
    setCurrentPage(0);
  }

  useEffect(() => {
    if (accessHistoryList.length) {
      setFilteredHistoryData(
        accessHistoryList.filter(({ cpf }) => {
          if (seeAllHistoryOrMyHistory === 'seeAll') return cpf !== user.cpf;
          return cpf === user.cpf;
        }),
      );
    }
  }, [accessHistoryList, seeAllHistoryOrMyHistory]);

  return (
    <>
      <div className="containerAcessHistory">
        <div className="accessHistoryHeader">
          <h1 className="pageTitle">Quem acessou meu RES?</h1>
        </div>
        <div className="accessHistoryBody">
          <div className="accessHistoryTab">
            <button
              className={
                seeAllHistoryOrMyHistory === 'seeAll'
                  ? 'tabButtonClicked'
                  : 'tabButtonNonClicked'
              }
              onClick={handleAllHistory}
            >
              Histórico de acessos
            </button>
            <button
              className={
                seeAllHistoryOrMyHistory === 'seeMine'
                  ? 'tabButtonClicked'
                  : 'tabButtonNonClicked'
              }
              onClick={handleMyHistory}
            >
              Meu histórico
            </button>
          </div>
          {loading ? (
            <LoadingHU state={loading} />
          ) : (
            <div className="tableContainer">
              <TableAccessHistory
                table={filteredHistoryData.slice(startIndex, endIndex)}
                type={seeAllHistoryOrMyHistory}
              />
              {
                filteredHistoryData.length > 0 && (
                <PaginationComponent
                  items={itensPerPage}
                  totalItens={filteredHistoryData.length}
                  setItensPerPage={setItensPerPage}
                  setCurrentPage={setCurrentPage}
                  pages={pages}
                  currentPage={currentPage}
                />
                )
              }

            </div>
          )}
        </div>
      </div>
    </>
  );
}
